import { useCallback, useMemo } from 'react';

import { useForm } from 'react-final-form';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { GENERAL_ERROR_MESSAGE } from 'constants/texts';
import { showSnackbar } from 'hooks/useSnackbar';
import { confirmAlert } from 'utils/alert';

import { getDefaultFilter } from '../functions';

export function useItinerarySearchFilter({ filter, filterName, filterKeyName }) {
  const showRadioButtons = true;
  const defaultFilter = useMemo(() => getDefaultFilter(), []);
  const restoredFilter = useMemo(() => filter || getDefaultFilter(filter), [filter]);

  const form = useForm();

  const handleDelete = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      confirmAlert({
        title: 'Are you sure you want to delete this filter?',
        onConfirm: async () => {
          try {
            form.change(filterKeyName, null);
          } catch (err) {
            showSnackbar({ text: GENERAL_ERROR_MESSAGE, type: SNACKBAR_SKIN.ERROR });
          }
        },
      });
    },
    [form, filterKeyName],
  );

  const handleSave = useCallback(
    async (filter) => {
      form.change(filterKeyName, filter);
      showSnackbar({ text: 'Filters have been saved.' });
    },
    [form, filterKeyName],
  );

  return {
    title: `Filter ${filterName}`,
    defaultFilter,
    restoredFilter,
    showRadioButtons,
    handleDelete,
    handleSave,
  };
}
